module.exports = __webpack_public_path__ + "static/assets/a5e2b9116ac3d90aed7a1e56c52d9fbd.png";